export const UPLOAD_COMPANIES_CSV = 'UPLOAD_COMPANIES_CSV'
export const UPLOAD_COMPANIES_CSV_SUCCESS = 'UPLOAD_COMPANIES_CSV_SUCCESS'
export const GET_COMPANIES_DATA = 'GET_COMPANIES_DATA'
export const GET_COMPANIES_DATA_SUCCESS = 'GET_COMPANIES_DATA_SUCCESS'
export const ADD_COMPANY = 'ADD_COMPANY'
export const ADD_COMPANY_SUCCESS = 'ADD_COMPANY_SUCCESS'
export const EDIT_COMPANY = 'EDIT_COMPANY'
export const EDIT_COMPANY_SUCCESS = 'EDIT_COMPANY_SUCCESS'
export const DELETE_COMPANY_SUCCESS = 'DELETE_COMPANY_SUCCESS'
